"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = exports.ContentContainer = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var TabBar_1 = require("./TabBar");
var TabContent_1 = require("./TabContent");
var Container = styled_components_1.default.div.attrs({
    className: 'tabs-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var BarsContainer = styled_components_1.default.ul.attrs({
    className: 'tab-bar-container',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tlist-style-type: none;\n\tmargin-top: ", ";\n\tmargin-bottom: ", ";\n\tpadding: ", ";\n\tdisplay: flex;\n"], ["\n\tlist-style-type: none;\n\tmargin-top: ", ";\n\tmargin-bottom: ", ";\n\tpadding: ", ";\n\tdisplay: flex;\n"])), globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.spacing0);
exports.ContentContainer = styled_components_1.default.div.attrs({
    className: 'tab-content-container',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin-top: ", ";\n\tmin-height: ", ";\n\t", "\n"], ["\n\tmargin-top: ", ";\n\tmin-height: ", ";\n\t", "\n"])), globalVars_module_scss_1.default.spacing10, function (props) { return props.minHeight; }, function (props) { return (props.height ? "height: ".concat(props.height, "; overflow: auto;") : ''); });
exports.ContentContainer.displayName = 'ContentContainer';
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            activeKey: _this.props.activeKey,
        };
        _this.onTabClick = _this.onTabClick.bind(_this);
        return _this;
    }
    Tabs.prototype.render = function () {
        var _this = this;
        var _a = this.props, isLoading = _a.isLoading, loadingRender = _a.loadingRender;
        var activeKey = this.state.activeKey;
        var tabBars = [];
        var tabContent;
        var tabActiveKey = activeKey;
        tabBars = React.Children.map(this.props.children, function (child, index) {
            if (!tabActiveKey && index === 0) {
                tabActiveKey = child.props.tabKey;
            }
            if (child.props.tabKey === tabActiveKey) {
                tabContent = React.createElement(TabContent_1.TabContent, { key: "tab-content-".concat(index) }, child.props.children);
            }
            return React.createElement(TabBar_1.TabBar, __assign({ onTabClick: _this.onTabClick }, child.props, { activeKey: tabActiveKey }));
        });
        return (React.createElement(Container, { activeKey: activeKey, className: this.props.className },
            React.createElement(BarsContainer, null, tabBars),
            React.createElement(exports.ContentContainer, __assign({}, this.props), loadingRender && isLoading ? loadingRender : tabContent)));
    };
    Tabs.prototype.onTabClick = function (tabKey) {
        this.setState({ activeKey: tabKey });
        var onTabClick = this.props.onTabClick;
        if (onTabClick) {
            onTabClick(tabKey);
        }
    };
    // Default props
    Tabs.defaultProps = {
        minHeight: 'auto',
    };
    return Tabs;
}(React.Component));
exports.Tabs = Tabs;
var templateObject_1, templateObject_2, templateObject_3;
